// assets/section-main-search.js
// Search page: two independently paginated result columns (products | articles).
// A column the page didn't render itself (it carries data-search-src) fetches a
// search for its own type through the Section Rendering API and is swapped for
// the column in the response. "Load more" fetches the column's next page and
// appends its rows. All markup comes from the section's own Liquid output.
if (!window.DigitalizModules) window.DigitalizModules = {};
if (!window.DigitalizModules.MainSearch) {
  class MainSearch {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      this.onClick = this.onClick.bind(this);
      this.init();
    }

    init() {
      if (!this.sectionId) return;
      this.el.addEventListener("click", this.onClick);
      this.el.querySelectorAll("[data-search-column][data-search-src]").forEach((column) => {
        this.loadColumn(column);
      });
    }

    destroy() {
      this.el.removeEventListener("click", this.onClick);
    }

    // Fetches `url` rendered as this section and returns its column of `type`.
    async fetchColumn(url, type) {
      const target = new URL(url, window.location.origin);
      target.searchParams.set("section_id", this.sectionId);
      const response = await fetch(target.toString(), { headers: { Accept: "text/html" } });
      if (!response.ok) throw new Error(`Search request failed (${response.status})`);
      const doc = new DOMParser().parseFromString(await response.text(), "text/html");
      return doc.querySelector(`[data-search-column="${type}"]`);
    }

    async loadColumn(column) {
      try {
        const rendered = await this.fetchColumn(column.dataset.searchSrc, column.dataset.searchColumn);
        if (rendered && !rendered.hasAttribute("data-search-src")) {
          column.replaceWith(document.adoptNode(rendered));
          return;
        }
      } catch (error) {
        // Fall through: stop the loading state rather than spin forever.
      }
      column.removeAttribute("aria-busy");
      column.querySelector(".main-search__spinner")?.remove();
    }

    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest("[data-search-more]");
      if (button && this.el.contains(button)) this.loadMore(button);
    }

    async loadMore(button) {
      const column = button.closest("[data-search-column]");
      const list = column?.querySelector("[data-search-list]");
      const nextUrl = button.dataset.nextUrl;
      if (!column || !list || !nextUrl || button.disabled) return;

      button.disabled = true;
      column.setAttribute("aria-busy", "true");

      try {
        const rendered = await this.fetchColumn(nextUrl, column.dataset.searchColumn);
        const items = rendered ? [...rendered.querySelectorAll("[data-search-item]")] : [];
        items.forEach((item) => list.appendChild(document.adoptNode(item)));

        const nextButton = rendered?.querySelector("[data-search-more]");
        if (nextButton?.dataset.nextUrl) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
          button.disabled = false;
        } else {
          button.closest("[data-search-more-wrap]")?.remove();
        }

        // Keep keyboard users in place: move focus to the first new result.
        items[0]?.querySelector("a")?.focus();
      } catch (error) {
        button.disabled = false;
      } finally {
        column.removeAttribute("aria-busy");
      }
    }
  }

  window.DigitalizModules.MainSearch = MainSearch;

  document.querySelectorAll("[data-main-search]").forEach((el) => {
    new MainSearch(el);
  });
}
